<template>
  <div class="group-tags">
    <el-tag
      v-for="(tag, index) in pageGroup"
      :key="index"
      :closable="pageGroup.length > 1"
      @click="emit('input', index)"
      @close="emit('remove', index)"
      :type="tagModel === index ? '' : 'info'"
      style="cursor: pointer"
    >
      {{ `组合${index + 1}` }}
    </el-tag>
    <slot name="btn">
      <el-button type="text" v-if="pageGroup && pageGroup.length < 3" @click="emit('add')">+添加</el-button>
    </slot>
  </div>
</template>

<script setup>
import { ref, toRef } from 'vue'

// eslint-disable-next-line
const props = defineProps({
  value: Number,
  pageGroup: Array
})
// eslint-disable-next-line
const emit = defineEmits(['input', 'remove', 'add'])
const tagModel = toRef(props, 'value')
</script>

<style lang="scss" scoped>
.group-tags {
  .el-tag {
    margin-right: 10px;
  }
}
</style>
